import {WorkflowConfigService} from '@ispm/workflow/services/workflow-config.service';
import {Store} from '@ngrx/store';
import {prefetchDataModel} from '@ispm/test/services/prefetch-data/prefetch-data.model';
import {filter, take, map} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {ConfigurationStoreHandler} from '../../../configuration/services/configuration-store-handler.service';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';
import {testViewPathologistPath, testViewWithPatientProfile} from '@ispm/test/routes/test-view-state-names';
import {DiagnosticOrderActionsService} from '@ispm/test/services/diagnostic-order-actions.service';
import {CoreActionCreatorService} from '@ispm/core/services/core-action-creator.service';
import {WorkflowService} from '@ispm/workflow/services/workflow.service';
import {DiagnosticOrderService} from '../services/diagnostic-order.service';
import {UserService} from "@ispm/user/services/user.service";
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';
import {QcService} from "../../../quality-check/services/qc.service";
import {TestService} from "@ispm/test/services/test.service";
import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanDeactivate,
  Resolve,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import {Injectable} from "@angular/core";
import {LogService} from '@ispm/core/services/log.service';
import _, {get, has} from "lodash";
import {PollJobService} from "@ispm/test/services/poll-job.service";
import {OrganizationService} from "@ispm/migration/services/organization.service";
import {MDTDecisionTreeService} from "@ispm/widgets/components/decision-tree-capture/services/mdt-decision-tree.service";
import {AgregationService} from "@ispm-client/modules/aggregator/services";
import {MDTTypePayloadTypeConfig} from "@ispm/widgets/components/decision-tree-capture/interfaces/mdt-type-map.interface";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {NotificationStoreHandler} from "@ispm/shared/notification/service/notification-store-handler";
import {NavigationHelperService} from "@ispm/core/services/navigation-helper.service";

@Injectable({providedIn: 'root'})
export class resolveWorkflow {
  constructor(private workflowConfig: WorkflowConfigService,private navigationHelperService: NavigationHelperService) {
  }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    let additionalPayload = this.navigationHelperService.getNavigationParams();
    let routParams = {}
    if(!_.isEmpty(additionalPayload)){
      routParams =  additionalPayload;
    }
    return this.workflowConfig.changeWorkflow(activatedRouteSnapshot.params.testId, activatedRouteSnapshot.params.revisionId,routParams)
      .take(1)
      .toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class prepareStore {
  constructor(
    private diagnosticOrderActionsService : DiagnosticOrderActionsService,
    private workflowService: WorkflowService,
    private testService: TestService,
    private configurationStoreHandler: ConfigurationStoreHandler,
    private authService: AuthenticationService,
    private route: Router,
    private testServiceTS: TestService,
    private notificationStoreHandler: NotificationStoreHandler
  ) {
  }

  resolveTotalTestsForPrepareStore(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    let params = {
      patientId: activatedRouteSnapshot.parent.params.patientId,
      testId: activatedRouteSnapshot.params.testId,
      revisionId: activatedRouteSnapshot.params.revisionId
    }
    return this.diagnosticOrderActionsService.getState()
      .take(1)
      .map(state => state.allOrders.toArray())
      .flatMap( async (orders) => {
        return await this.workflowService.getPatientAnalysisAllData(params, true)
          .then((res) => {
            if (orders.length !== res.ordersCount) {
              this.diagnosticOrderActionsService.setAllDiagnosticOrders(res.patientAnalysis.allTests);
            }
            if (!!activatedRouteSnapshot.params.testId) {
              this.testService.patientTests = res.patientAnalysisById;
              if (!(this.testService.patientTests
                && this.testService.patientTests.current
                && this.testService.patientTests.current.workflowRequest
                && this.testService.patientTests.current.workflowRequest.revisions)) {
                return Observable.empty();
              }
              this.diagnosticOrderActionsService.setDiagnosticOrder(this.testService.patientTests.current);
              return this.testService.patientTests.current;
            } else {
              this.diagnosticOrderActionsService.initDiagnosticOrder();
              return Observable.empty();
            }
          })
      });
  }


  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise((resolve, reject) => {
      this.resolveTotalTestsForPrepareStore(activatedRouteSnapshot).subscribe(data => {
        let diagnosticOrder = data;
        this.configurationStoreHandler.getCurrentConfig()
          .pipe(filter(conf => !!conf), take(1))
          .subscribe(testConfiguration => {
            const notificationConfig = this.testService.getNotifConfigurationByDiagnosticOrder(diagnosticOrder, testConfiguration);
            this.notificationStoreHandler.setNotification(notificationConfig);
          });
        if (diagnosticOrder) {
          const test = this.testServiceTS.selectTestConfiguration(diagnosticOrder, this.authService.user.organization);
          if (this.testServiceTS.isItCached(test)) {
            this.testServiceTS.getCachedTest(test)
              .then((testConfig) => {
                this.testServiceTS.testConfiguration = testConfig;
                stateRouting(this.route, activatedRouteSnapshot, this.testServiceTS, state);
                resolve(this.testServiceTS.testConfiguration);
              })
              .catch(function (error) {
                reject(error);
              });
          } else {
            this.testServiceTS.getTestConfiguration(this.testServiceTS.selectTestConfiguration(diagnosticOrder, this.authService.user.organization))
              .then(() => {
                this.testServiceTS.putConfig(this.testServiceTS.testConfiguration.id, this.testServiceTS.testConfiguration);
                stateRouting(this.route, activatedRouteSnapshot, this.testServiceTS, state);
                resolve(this.testServiceTS.testConfiguration);
              })
              .catch(function (error) {
                reject(error);
              });
          }
        } else {
          resolve(null);
        }
      });
    });
  }
}

@Injectable({providedIn: 'root'})
export class changeWorkFlow {
  constructor(
    private workflowConfig: WorkflowConfigService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.workflowConfig.changeWorkflowWithoutClearingCach(activatedRouteSnapshot.params.testId, activatedRouteSnapshot.params.revisionId)
      .take(1)
      .toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class resolveClearCachedData {
  constructor(
    private workflowConfig: WorkflowConfigService
  ) {
  }

  resolve() {
    return this.workflowConfig.clearAllCachedData();
  }
}

@Injectable({providedIn: 'root'})
export class resolveDiagnosticOrderUsingOrderId {
  constructor(
    private diagnosticOrder: DiagnosticOrderService,
    private diagnosticOrderActions: DiagnosticOrderActionsService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.diagnosticOrder.getDiagnosticOrder(activatedRouteSnapshot.params.orderId).then(testResponse => {
      this.diagnosticOrderActions.setDiagnosticOrder(testResponse.body); // TODO: Deal with order not found/errors in general.
      return testResponse.body;
    });
  }
}

@Injectable({providedIn: 'root'})
export class resolveQcResults {
  constructor(
    private qcService: QcService,
    private workflowConfigService: WorkflowConfigService,
    private definitionAC: ConfigurationStoreHandler
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.workflowConfigService.getActiveWorkflow(false)
      .filter(workflow => !!workflow)
      .take(1)
      .switchMap(() => this.definitionAC.getCurrentConfig().pipe(filter(conf => !!conf), take(1)))
      .flatMap((config) => !get(config, 'qcConfig.disabled', false) ? this.qcService.getQcResults(false, activatedRouteSnapshot.params.revisionId) : Observable.empty())
      .toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class resolvePrefetchData {
  constructor(
    private store: Store<any>,
    private configurationStoreHandler: ConfigurationStoreHandler
  ) {
  }

  resolve() {
    this.configurationStoreHandler.getCurrentConfig()
      .pipe(filter(conf => !!conf), take(1))
      .subscribe(testConfiguration => {
        const prefetchDataMode = testConfiguration.prefetchDataMode;
        const enabled = prefetchDataMode ? prefetchDataMode.enabled : false;
        let type;
        if (prefetchDataMode) {
          type = prefetchDataMode.type ? prefetchDataMode.type : undefined;
        }
        if (prefetchDataMode && enabled && type) {
          triggerPrefetchData(type, this.store);
        }
      });
  }
}

function triggerPrefetchData(type: string, store: Store<any>) {
  const actions = _.get(prefetchDataModel, type);
  if (actions) {
    actions.forEach((action) => {
      store.dispatch(new action);
    });
  }
}

@Injectable({providedIn: 'root'})
export class  resolveTotalTests implements Resolve<any>{
  constructor(
    private diagnosticOrderActionsService : DiagnosticOrderActionsService,
    private workflowService: WorkflowService,
    private testService: TestService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    let params = {
      patientId: activatedRouteSnapshot.params.patientId,
      testId: activatedRouteSnapshot.firstChild.params.testId,
      revisionId: activatedRouteSnapshot.firstChild.params.revisionId
    }
    return this.diagnosticOrderActionsService.getState()
      .take(1)
      .map(state => state.allOrders.toArray())
      .flatMap( async (orders) => {
        return await this.workflowService.getPatientAnalysisAllData(params, true)
          .then((res) => {
            if (orders.length !== res.ordersCount) {
              this.diagnosticOrderActionsService.setAllDiagnosticOrders(res.patientAnalysis.allTests);
            }

            if (!!activatedRouteSnapshot.firstChild.params.testId) {
              this.testService.patientTests = res.patientAnalysisById;

              if (!(this.testService.patientTests
                && this.testService.patientTests.current
                && this.testService.patientTests.current.workflowRequest
                && this.testService.patientTests.current.workflowRequest.revisions)
              ) {
                return Observable.empty();
              }

              this.diagnosticOrderActionsService.setDiagnosticOrder(this.testService.patientTests.current);
              return this.testService.patientTests.current;
            } else {
              this.diagnosticOrderActionsService.initDiagnosticOrder();
              return Observable.empty();
            }
          })
    }).toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class  resetNotification implements CanDeactivate<any>{
  constructor(
    private notificationStoreHandler: NotificationStoreHandler
  ) {
  }

  canDeactivate(): boolean {
    this.notificationStoreHandler.clearNotification();
    return true;
  }
}

function stateRouting(route, transition, testService, state) {
  if (state && state.url.includes(testViewWithPatientProfile)) {
    const hasOwnPropertyPathwayTest = testService.testConfiguration && testService.testConfiguration.hasOwnProperty('isPathwayTest');
    if (!hasOwnPropertyPathwayTest || (hasOwnPropertyPathwayTest && !testService.testConfiguration.isPathwayTest)) {
      const params = {
        patientId: transition.parent.params.patientId,
        testId: transition.params.testId,
        revisionId: transition.params.revisionId
      };
      const queryParams = transition?.queryParams;
      route.navigate([testViewPathologistPath,params.patientId,params.testId,params.revisionId], {queryParams: queryParams, queryParamsHandling: 'preserve', skipLocationChange : true});
      console.log('Navigate to profile test pathologist Pathologist/' + params.patientId + '/' + params.testId + '/' + params.revisionId)
    }
  }
}

@Injectable({providedIn: 'root'})
export class resolveIsPatientContext {
  resolve()
  {
    return true;
  }
}

@Injectable({providedIn: 'root'})
export class resolveCustomConfigPathologist {
  resolve() {
    return true;
  }
}

@Injectable({providedIn: 'root'})
export class resolveCustomConfigPathologistPatient {
  resolve() {
    return false;
  }
}

@Injectable({providedIn: 'root'})
export class resolveContextParam {
  resolve() {
    return 'patientId';
  }
}

@Injectable({providedIn: 'root'})
export class resolveUserData {
  constructor(
    private userService: UserService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.userService.getPatient(activatedRouteSnapshot.parent.params.patientId).pipe(take(1)).subscribe();
  }
}

@Injectable({providedIn: 'root'})
export class resolvePatientLink {
  constructor(
    private userService: UserService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.userService.getPatientLink(activatedRouteSnapshot.parent.params.patientId);
  }
}

@Injectable({providedIn: 'root'})
export class resolveCurrentPatientIdentifier {
  constructor(
    private patientService: PatientService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.patientService.storeCurrentPatientAggIdentifiers(activatedRouteSnapshot.parent.params.patientId).subscribe();
  }
}

@Injectable({providedIn: 'root'})
export class resolveLayoutEngineParams{
  constructor(
    private testService: TestService,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService,
    private ispmHttpClient: IspmHttpClient,
    private aggregatorService: AgregationService,
    private mdtDecisionService: MDTDecisionTreeService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    let payload = '';
    const layoutConfig = get(this.testService.testConfiguration, `layoutEngine`);

    if (get(activatedRouteSnapshot.queryParams, 'payload')) {
      payload = get(activatedRouteSnapshot.queryParams, 'payload');
    }

    const layoutParams = get(layoutConfig, `${payload}`);

    // layout engine params triggers on letters, which will stop switching to new case from all items
    if(!layoutParams){
      return ;
    }

    return this.diagnosticOrderActionsService.getState()
      .filter(state => !!state.order && Object.keys(state.order).length > 0)
      .take(1)
      .switchMap(state => {
        const current = state.order;
        // get cancer type from condition resource
        if (current['organization']) {
          this.aggregatorService.updateCurrentInstanceData({organization: current['organization']});
        }
        if (current['MDTType']) {
          this.aggregatorService.updateCurrentInstanceData({MDTType: current['MDTType']});
        }
        if (has(current, 'snapshot')) {
          if (get(current, 'snapshot')) {
            layoutParams['snapshot'] = 'snapshot';
          } else {
            layoutParams['snapshot'] = 'noSnapshot';
          }
        }
        if (get(current, 'condition.reference')) {
          const conditionPayload = {
            'queries': [{
              'targetResource': 'Condition',
              'queryString': `_id=${get(current, 'condition.reference')}&subResourceTypeCode=primary_cancer&categoryCode=primary&_fieldslist=cancerType,clinicalPhase`
            }]
          };

          return this.ispmHttpClient.post('bundleUtil/search', conditionPayload).pipe(
            take(1),
            map(val => {
            let cancerType = '';
            let clinicalPhase = '';
            const entry = val[0].response.entry;
            entry.forEach(element => {
              if (element.resource.cancerType) {
                this.aggregatorService.updateCurrentInstanceData({'cancerType': element.resource.cancerType});
                cancerType += element.resource.cancerType.code + ',';
              }
              if (element.resource.clinicalPhase) {
                this.aggregatorService.updateCurrentInstanceData({'clinicalPhase': element.resource.clinicalPhase});
                clinicalPhase += element.resource.clinicalPhase.code + ',';
              }
            });
            cancerType = cancerType.slice(0, cancerType.length - 1);
            clinicalPhase = clinicalPhase.slice(0, clinicalPhase.length - 1);

            if (current['MDTType'] && cancerType) {
              const mdtType: string = current['MDTType'].code;
              this.mdtDecisionService.storeCurrentMDTConfig(mdtType, cancerType);
            } else {
              this.mdtDecisionService.storeSelectedMDTtypeConfig(<MDTTypePayloadTypeConfig>{});
            }

            if (cancerType) {
              layoutParams['cancerType'] = cancerType;
            }
            if (clinicalPhase) {
              layoutParams['clinicalPhase'] = clinicalPhase;
            }
            return layoutParams;
          }));
        } else {
          return Observable.of(layoutParams);
        }
      });
  }
}

@Injectable({providedIn: 'root'})
export class resolvePollingUntilStep {
  constructor(
    private pollJobService: PollJobService,
    private configurationStoreHandler: ConfigurationStoreHandler
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const workflowId = activatedRouteSnapshot.params.testId;
    const revisionId = activatedRouteSnapshot.params.revisionId;

      this.configurationStoreHandler.getCurrentConfig()
        .pipe(filter(conf => !!conf), take(1))
        .subscribe(testConfiguration => {
          return this.pollJobService.pollingUntilStep(revisionId, workflowId, testConfiguration);
        });
  }
}

@Injectable({providedIn: 'root'})
export class resolvePatient {
  constructor(
    private patientService: PatientService,
    private userActionCreatorService: UserActionCreatorService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot)
  {
    if (activatedRouteSnapshot.parent.params.patientId) {
      this.patientService.get(activatedRouteSnapshot.parent.params.patientId).subscribe((res) => {
        this.userActionCreatorService.updatePatient(activatedRouteSnapshot.parent.params.patientId, res);
      });

      return this.patientService.get(activatedRouteSnapshot.parent.params.patientId).toPromise();
    }
  }
}

@Injectable()
export class ExitGuard implements CanDeactivate<any> {
  canDeactivate(component: any): boolean {
    if (component && component.onExit) {
      component.onExit();
    }
    return true;
  }
}

@Injectable({providedIn: 'root'})
export class resolvePatientParams {
  constructor(
    private patientService: PatientService,
    private coreActionCreatorService: CoreActionCreatorService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    this.coreActionCreatorService.setLoader(true);
    if (route.params.patientId) {
      return this.patientService.get(route.params.patientId).toPromise();
    } else if (route.params.mrn) {
      return null;
    } else {
      return new Promise((resolve) => resolve({}));
    }
  }
}

@Injectable({providedIn: 'root'})
export class resolveOrgsParams {
  constructor(
    private organizationService: OrganizationService
  ) {
  }

  resolve() {
    return this.organizationService.getOrganizations('', 'dept,lab,prov').toPromise();
  }
}

@Injectable({providedIn: 'root'})
export class resolveTestTypesParams {
  constructor(
    private diagnosticOrderService: DiagnosticOrderService,
    private authenticationService: AuthenticationService
  ) {
  }

  resolve() {
    let user = this.authenticationService.getUser();
    if (user.role == "GenomicsAdminGroup") {
      user.organization = sessionStorage.getItem("adminSelectOrganizationId");
    }
    return this.diagnosticOrderService.getTemplates({OrganizationId: user.organization}).toPromise();
  }
}


@Injectable({providedIn: 'root'})
export class redirectToPathologist implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private route: Router,
    private testServiceTS: TestService
  ) {
  }

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let diagnosticOrder = activatedRouteSnapshot.parent.data['currentDiagnosticOrder'];
    stateRouting(this.route, activatedRouteSnapshot, this.testServiceTS, state);
    if (diagnosticOrder) {
      const test = this.testServiceTS.selectTestConfiguration(diagnosticOrder, this.authService.user.organization);
      // const orderId =diagnosticOrder.orderer// diagnosticOrder.id; //diagnosticOrder.orderer
      if (this.testServiceTS.isItCached(test)) {
        return this.testServiceTS.getCachedTest(test)
          .then((testConfig) => {
            this.testServiceTS.testConfiguration = testConfig;
            stateRouting(this.route, activatedRouteSnapshot, this.testServiceTS, state)
            return this.testServiceTS.testConfiguration;
          })
          .catch(() => null);
      } else {
        return this.testServiceTS.getTestConfiguration(this.testServiceTS.selectTestConfiguration(diagnosticOrder, this.authService.user.organization)).then(() => {
          this.testServiceTS.putConfig(this.testServiceTS.testConfiguration.id, this.testServiceTS.testConfiguration);
          stateRouting(this.route, activatedRouteSnapshot, this.testServiceTS, state)
          return this.testServiceTS.testConfiguration;
        });
      }
    } else {
      return null;
    }
  }
}

@Injectable({providedIn: 'root'})
export class redirectToTestView implements CanActivate {
  constructor(
    private logService: LogService,
    private route: Router,
    private workflowService: WorkflowService,
    private testService: TestService,
    private authService: AuthenticationService,
    protected routerManagerService: RouterManagerService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return new Promise((resolve, reject) => {
      let transactionId = next.params.transactionId || this.logService.generateTransactionId();
      if (!next.params.revisionId) {
        let params = Object.assign({}, next.params);
        const hasTestId = !!next.params.testId;
        let customOption = next.params.custom;
        if (customOption && customOption.emptyPage) {
          resolve(null);
        }
        this.logService.info(`Inside Pathologist.profile.test state, Before Patient Analysis`, '[test-view-routes]', transactionId)
        this.workflowService.getPatientAnalyses(next, hasTestId).then((res) => {
          if (res.body.current) {
            const currentRevisions = hasTestId ? res.body.current.workflowRequest.revisions : res.body.current.revisions;
            if (currentRevisions[currentRevisions.length - 1].id) {
              params.testId = hasTestId ? res.body.current.workflowRequest.id : res.body.current.id;
              params.revisionId = currentRevisions[currentRevisions.length - 1].id;
              this.logService.info(`Inside Pathologist.profile.test state, After Patient Analyses, now redirecting...,`, '[test-view-routes]', transactionId)
              this.route.navigate(['Pathologist/', {queryParams: params}]);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        }).catch(() => {
          resolve(null);
        });
      } else {
        let testConfiguration = this.testService.testConfiguration;
        let testConfigurationPromise;
        if (testConfiguration) {
          testConfigurationPromise = Promise.resolve(testConfiguration);
        } else {
          testConfigurationPromise = this.workflowService.getPatientAnalyses(next, true, false)
            .then(res => res.body)
            .then(tests => {
              if (tests) {
                return this.testService.getTestConfiguration(
                  this.testService.selectTestConfiguration(tests.current, this.authService.user.organization))
              } else {
                resolve(Promise.reject(new Error('Could not retrieve patient tests')));
              }
            }).catch(error => {
              let errMsg = "Could not resolve 'tests': " + error;
              console.log(errMsg);
              return (Promise.reject(new Error(errMsg)));
            });
        }
        testConfigurationPromise.then(() => {
          let testConfiguration = this.testService.testConfiguration;
          let redirectTo = null;
          if (testConfiguration && testConfiguration.testViewVersion) {
            switch (testConfiguration.testViewVersion) {
              case 2: {
                redirectTo = [
                  'Pathologist/PatientProfile/:patientId/:testId/:revisionId/info',
                  {queryParams: next.params}
                ];
                break;
              }
              default: {
                redirectTo = null;
              }
            }
          }
          this.logService.info(`Inside Pathologist.profile.test state, Before redirect to ${redirectTo}`, '[test-view-route]', transactionId);
          resolve(this.route.navigate([this.routerManagerService.setParamsInURL(redirectTo[0], redirectTo[1].queryParams)], {queryParams: next.params}));
        }).catch(error => {
          console.log("redirectTo got error: " + error);
          resolve(null);
        });
      }
    });
  }
}

@Injectable({providedIn: 'root'})
export class resolveCustomTotalTests {
  constructor(
    private workflowService: WorkflowService,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.diagnosticOrderActionsService.getState()
      .take(1)
      .map(state => state.allOrders.toArray())
      .flatMap((orders) => {
        return this.workflowService.getTotalTests(activatedRouteSnapshot.parent.params.patientId).then(res => {
            if (orders.length !== res.body.count) {
              //initiating empty objects as placeholder for performance improvement (loading the tests might take a while)
              let arr = [];
              arr.length = res.body.count;
              this.diagnosticOrderActionsService.setAllDiagnosticOrders(arr);
            }
            return res.body.count;
          }).catch(() => null);
      });
  }
}

@Injectable({providedIn: 'root'})
export class resolveTests {
  constructor(
    private workflowService: WorkflowService,
    private testService: TestService,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const params = {
      patientId: activatedRouteSnapshot.parent.params.patientId,
      testId: activatedRouteSnapshot.params.testId,
      revisionId: activatedRouteSnapshot.params.revisionId
    }
    if (!!activatedRouteSnapshot.params.testId) {
      return this.workflowService.getPatientAnalyses(params, true, true)
        .then( (res) => {
          if (res.data) {
            this.testService.patientTests = res.data;
          }
          if (res.body) {
            this.testService.patientTests = res.body;
          }

          if (!(this.testService.patientTests
            && this.testService.patientTests.current
            && this.testService.patientTests.current.workflowRequest
            && this.testService.patientTests.current.workflowRequest.revisions)) return null;
          this.diagnosticOrderActionsService.setDiagnosticOrder(this.testService.patientTests.current);
          return this.testService.patientTests;
        })
        .catch(() => {
          this.testService.clearTests();
          return this.testService.patientTests;
        })
    } else {
      this.diagnosticOrderActionsService.initDiagnosticOrder();
      return null;
    }
  }
}

@Injectable({providedIn: 'root'})
export class resolveTestConfig {
  constructor(
    private authService: AuthenticationService,
    private testService: TestService,
    private qcService: QcService,
    private workflowService: WorkflowService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const params = {
      patientId: route.parent.params.patientId,
      testId: route.params.testId,
      revisionId: route.params.revisionId
    }
    return this.workflowService.getPatientAnalyses(params, true, true)
      .then((res) => {
        if (res.body) {
          return this.testService.getTestConfiguration(this.testService.selectTestConfiguration(res.body.current, this.authService.user.organization)).then((data) => {
            return this.qcService.getQcResults(false, res.body.current.workflowRequest.activeRevision)
              .toPromise()
              .then(qc => {
                if (Object.keys(qc).length > 0) {
                  this.testService.patientTests.current.qc = qc;
                }
                return data.body;
              })
              .catch(() => {
                return data.body;
              });
          });
        }
      });
  }
}

@Injectable({providedIn: 'root'})
export class resolvePathHomeParams {
  constructor(
    private authService: AuthenticationService,
    private coreActionCreatorService: CoreActionCreatorService,
    private workflowService: WorkflowService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    this.coreActionCreatorService.setLoader(true);
    const filter: any = activatedRouteSnapshot.params.mrn ? {
      MRN: activatedRouteSnapshot.params.mrn,
      patientId: activatedRouteSnapshot.params.patientId
    } : '%7B%7D';
    let displayMyWorklist = this.authService.getLocalSetting('displayMyWorklist', true);
    if (filter.MRN || filter.patientId) {
      displayMyWorklist = false;
    }
    return this.workflowService.getPathWorkList(displayMyWorklist, filter, this.authService.user).toPromise()
      .catch(() => {
        if (displayMyWorklist) {
          return this.workflowService.getPathWorkList(false, filter, this.authService.user).toPromise().finally(() => {
            this.coreActionCreatorService.setLoader(false);
          });
        }
      })
      .catch(() => {
        this.coreActionCreatorService.setLoader(false);
        return {};
      })
      .finally(() => {
        this.coreActionCreatorService.setLoader(false);
      });
  }
}
